import React, { useContext, useState } from "react";
import { Menu, Dropdown, Icon } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import axios from "axios";

import { GlobalContext } from "../../../app/providers/GlobalState";

import InitialsAvatar from "../../../shared/components/InitialsAvatar";
import ModalListaParticipantes from "./ModalListaParticipantes";

const TituloModulo = ({
    modulo,
    botoesVisiveis,
    onOpenDrawerAula,
    colarTarefa,
    carregarModulo,
    excluirModulo,
    ativarModulo,
    carregarAulaHtml,
    excluirAulaUnica,
    ativarAulaUnica
}) => {
    const context = useContext(GlobalContext);

    const [loading, setLoading] = useState(false);
    const [visibleParticipantes, setVisibleParticipantes] = useState(false);
    const [participantes, setParticipantes] = useState([]);

    const estadoModulo = estado => {
        if (estado === "ATIVO") return <span className="modulo-semaforo verde" title="Ativo" />;
        else if (estado === "FECHADO") {
            return <span className="modulo-semaforo amarelo" title="Fechado" />;
        } else {
            return <span className="modulo-semaforo vermelho" title="Bloqueado" />;
        }
    };

    //MONTA AS OPÇÕES DE MENU POR MODULO
    const montarMenuModuloNormal = (moduloid, competencias, ordemAula, ativo) => {
        const acesso = context.acessos?.find(x => x.func === 18);

        return (
            <Menu>
                {acesso?.create && (
                    <Menu.Item key={"modulo_" + moduloid + "_add"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                onOpenDrawerAula(moduloid, ordemAula, competencias);
                            }}
                        >
                            Adicionar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {context.id_copia_tarefa > 0 ? (
                    <Menu.Item key={"modulo_" + moduloid + "_colar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                colarTarefa(context.id_copia_tarefa, moduloid);
                            }}
                        >
                            Colar tarefa
                        </Link>
                    </Menu.Item>
                ) : null}
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                carregarModulo(moduloid, competencias);
                            }}
                        >
                            Editar
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.delete && (
                    <Menu.Item key={"modulo_" + moduloid + "_excluir"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                excluirModulo(moduloid);
                            }}
                        >
                            Excluir
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_ativar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                ativarModulo(moduloid, ativo);
                            }}
                        >
                            {ativo ? "Ocultar" : "Mostrar"}
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const montarMenuModuloPaginaUnica = (moduloid, competencias, ativo, aula) => {
        const acesso = context.acessos?.find(x => x.func === 18);

        return (
            <Menu>
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                carregarModulo(moduloid, competencias);
                            }}
                        >
                            Editar
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.delete && (
                    <Menu.Item key={"modulo_" + moduloid + "_excluir"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                excluirModulo(moduloid);
                            }}
                        >
                            Excluir
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_ativar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                ativarModulo(moduloid, ativo);
                            }}
                        >
                            {ativo ? "Ocultar" : "Mostrar"}
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_editar_aula"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                carregarAulaHtml(moduloid, aula.id, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.delete && (
                    <Menu.Item key={"modulo_" + moduloid + "_excluir_aula"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                excluirAulaUnica(moduloid, aula.id);
                            }}
                        >
                            Excluir tarefa
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_ativar_aula"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                ativarAulaUnica(moduloid, aula.id, aula.ativo);
                            }}
                        >
                            {ativo ? "Ocultar tarefa" : "Mostrar tarefa"}
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const listarParticipantes = atividadeId => {
        setVisibleParticipantes(true);
        setLoading(true);

        axios({
            method: "get",
            url: "/api/gerir-curso-modulo/listar-participantes",
            params: {
                atividadeId
            }
        })
            .then(response => {
                setParticipantes(response.data);
                setLoading(false);
            })
            .catch(() => {});
    };

    const menu = modulo.pagina_unica
        ? montarMenuModuloPaginaUnica(modulo.id, modulo.competencias, modulo.ativo, modulo.modulo_Aula[0])
        : montarMenuModuloNormal(
              modulo.id,
              modulo.competencias,
              modulo.modulo_Aula.length > 0 ? modulo.modulo_Aula[modulo.modulo_Aula.length - 1].ordem + 1 : 1,
              modulo.ativo
          );

    return (
        <>
            <div>
                <div className="modulo-header">
                    <div className="modulo-container-esquerda">
                        {estadoModulo(modulo.estado)}
                        <span className="modulo-num">{modulo.nome}</span>
                        {modulo.precedencia && (
                            <span
                                className="modulo-precedencia"
                                title={`Precedência${modulo.obrigatoria ? " obrigatória" : ""}: ${modulo.precedencia}`}
                            >
                                <Icon type="api" className={modulo.obrigatoria ? "obrigatoria" : ""} />
                            </span>
                        )}
                        <span className="modulo-opcoes">
                            {botoesVisiveis && !modulo.conteudos_stepforma ? (
                                <Dropdown
                                    overlay={menu}
                                    placement="bottomLeft"
                                    onClick={event => {
                                        event.stopPropagation();
                                    }}
                                >
                                    <Link to="#" className="botao-icon-configs">
                                        <i className="fas fa-cog" />
                                    </Link>
                                </Dropdown>
                            ) : null}
                        </span>
                        {!modulo.todos && (
                            <div className="info-participante">
                                {modulo.totalParticipantes > 1 ? (
                                    <Link
                                        to="#"
                                        className="link-model-participantes"
                                        onClick={event => {
                                            listarParticipantes(modulo.id);
                                            event.stopPropagation();
                                        }}
                                    >
                                        <i className="fas fa-users icon-tipo-partilha partilhado"></i>
                                    </Link>
                                ) : (
                                    <>
                                        <div className="container-img">
                                            {modulo?.participante?.foto ? (
                                                <img src={modulo?.participante?.foto} />
                                            ) : (
                                                <InitialsAvatar name={modulo?.participante?.nome_completo} />
                                            )}
                                        </div>
                                        <div className="info">
                                            <span className="nome" style={{ color: "rgba(0, 0, 0, 0.8)" }}>
                                                {modulo?.participante?.nome_completo}
                                            </span>
                                            <p className="numero">{modulo?.participante?.numero}</p>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="modulo-container-direita">
                        <span className="modulo-datas">
                            {modulo.dt_inicio && (
                                <>
                                    Inicio: <strong>{moment(modulo.dt_inicio).format("DD/MM/YYYY")}</strong>
                                </>
                            )}{" "}
                            {modulo.dt_termino && (
                                <>
                                    Término: <strong>{moment(modulo.dt_termino).format("DD/MM/YYYY")}</strong>
                                </>
                            )}
                        </span>
                    </div>
                </div>
                {modulo.objetivos && (
                    <div className="modulo-header-objetivos">
                        <span>{modulo.objetivos}</span>
                    </div>
                )}
            </div>
            <ModalListaParticipantes
                loading={loading}
                participantes={participantes}
                visible={visibleParticipantes}
                setVisible={() => setVisibleParticipantes(false)}
            />
        </>
    );
};

export default TituloModulo;
